module.exports = __webpack_public_path__ + "img/fp.45f1e67b.png";